import { Button, Grid, Typography } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Input from "../../components/form-fields/Input";
import { changePassword as changePasswordRemote } from "../../helpers/services/UserServices";
import useStyles from "./ChangePassword.styles";

const ChangePassword = ({ login, location, user, errors }) => {
  const history = useHistory();
  const [errorMessage, setErrorMessage] = React.useState("");
  const styles = useStyles();
  const { t } = useTranslation();
  const changePassword = async (data) => {
    console.log(data);
    if (
      !data.old_password ||
      !data.new_password ||
      !data.new_password_confirm
    ) {
      setErrorMessage("Alle Felder müssen ausgefüllt werden");
    } else if (data.new_password !== data.new_password_confirm) {
      setErrorMessage("Neues Passwort und Bestätigung stimmen nicht überein");
    } else {
      try {
        await changePasswordRemote(data);
        history.push("/contracts");
      } catch (error) {
        setErrorMessage(error.message);
      }
    }
  };
  const handleCancelButton = () => {
    history.push("/contracts");
  };
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={styles.container}
    >
      <Grid item xs={10} sm={6} md={6} lg={4} xl={3}>
        <Formik
          initialValues={{
            old_password: "",
            new_password: "",
            new_password_confirm: "",
          }}
          onSubmit={(data, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            changePassword(data);
            setSubmitting(false);
            //resetForm();
          }}
        >
          {({ values, isSubmitting }) => (
            <div>
              <Typography variant="h6" color="primary" align="center">
                {t("links.Change password")}
              </Typography>
              <Form>
                <div>
                  <Input
                    name="old_password"
                    type="password"
                    label={t("system.oldPassword")}
                  />
                </div>
                <div>
                  <Input
                    name="new_password"
                    type="password"
                    label={t("system.newPassword")}
                  />
                </div>
                <div>
                  <Input
                    name="new_password_confirm"
                    type="password"
                    label={t("system.confirmPassword")}
                  />
                </div>
                <div className={styles.button_container}>
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={isSubmitting}
                    type="submit"
                  >
                    {t("links.Change password")}
                  </Button>
                  <Button
                    color="primary"
                    variant="outlined"
                    disabled={isSubmitting}
                    onClick={handleCancelButton}
                  >
                    {t("system.cancel_btn")}
                  </Button>
                </div>
              </Form>
            </div>
          )}
        </Formik>
        {errorMessage && (
          <div className={styles.errorMessage}>{errorMessage}</div>
        )}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({ user, errors }) => ({
  user,
  errors,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
